import type { BrandConfig } from './types';

export const pacConfig: BrandConfig = {
  brand: 'pac',
  portalTitle: 'PAC Portal',
  logoTitle: 'PAC',
  loginWelcome: 'Welcome to PAC Portal!',
  sentryProject: 'pacportal',
  sentryRelease: `pacportal@${__APP_VERSION__}`,
  // $color-brand-600 / $color-brand-800 under PAC. Kept as literals because
  // Vuetify's theme is built in TS, before any stylesheet is evaluated.
  vuetifyPrimary: '#2e8b4c',
  vuetifySecondary: '#235835',
  carouselImages: [
    new URL('@/assets/images/pac/image-1.jpg', import.meta.url).href,
    new URL('@/assets/images/pac/image-3.jpg', import.meta.url).href,
    new URL('@/assets/images/pac/image-4.jpg', import.meta.url).href,
    new URL('@/assets/images/pac/image-5.jpg', import.meta.url).href,
  ],
};
